import { FirstTimeLoginForm } from '@/components/auth/firstTimeLoginForm';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(first-login)/first-time-login')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('firstTimeLogin.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('firstTimeLogin.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg">
        <FirstTimeLoginForm />
      </CardContent>
    </>
  );
}
